import React from 'react';
import styles from './__styles__/index.scss?modules';
import { XSellBanner } from '../Banner';
import XSellCardTiles from '../CardTiles';

const XSellContainer = () => (
  <div className={styles.cardTileContainer}>
    <XSellBanner />
    <XSellCardTiles />
  </div>
);

export default React.memo(XSellContainer);
